export const bannerPresets = {
  adNumber: "",
  advertiser: "",
  advertiserId: "",
  asteriskSize: "",
  background: {
    path: "https://firebasestorage.googleapis.com/v0/b/dh-media-banners-42191.appspot.com/o/images%2Fbackground%2F1661433121523-2226-GHS-FIbanner-650x158-household.jpeg?alt=media&token=27e13f52-aa59-44c3-a4cf-b97699952c93",
    name: "placeholder background image",
  },
  backgroundPosition: "right",
  bannerTitle: "",
  bannerType: "trade",
  bannerURL: "",
  bespokeTemplate: true,
  bgColor: "#ffffff",
  buylistHeader: {
    path: "",
    name: "",
  },
  chevronColor: "#ffffff",
  clubcardPrice: true,
  ccpText: "Clubcard Price",
  ctaColor: "#00539f",
  currentUser: false,
  drinkaware: false,
  fiftyfifty: true,
  fontColor: "#ffffff",
  headline: "Heading",
  hidePanel: "no",
  includeAsterisk: false,
  includePanel: "yes",
  includeRegularPrice: false,
  invertCta: false,
  lastModAt: "",
  lastModBy: "",
  logo: {
    path: "",
    name: "",
  },
  newValueTile: false,
  orientation: "portrait",
  panelColor: "#00539f",
  panelOverride: "no",
  primaryPackshot: {
    path: "",
    name: "",
  },
  regularPrice: "Regular Price",
  regularPricePrice: "",
  regularPriceFontSize: "",
  retailer: "",
  secondaryPackshot: {
    path: "",
    name: "",
  },
  status: 2,
  strikethrough: false,
  subhead: "Subheading",
  terms: "Terms and conditions",
  tescoEvent: "",
  toggleThePower: false,
  valueTile: true,
  valueTileBackground: "#fcd700",
  valueTileBig: "",
  valueTileBottom: "",
  valueTileBottomFont: "",
  valueTileColor: "#000000",
  valueTileTop: "",
  valueTileTopFont: "",
  vtCurrency: "",
  vtWhite: false,
};
